import BrushIcon from '@mui/icons-material/Brush';

export default BrushIcon;
